import { render, staticRenderFns } from "./SSNewsListView.vue?vue&type=template&id=07025599&scoped=true&"
import script from "./SSNewsListView.vue?vue&type=script&lang=js&"
export * from "./SSNewsListView.vue?vue&type=script&lang=js&"
import style0 from "./SSNewsListView.vue?vue&type=style&index=0&id=07025599&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07025599",
  null
  
)

export default component.exports